import { Component } from '@angular/core';
import { Routes, RouterModule, RouterOutlet } from '@angular/router';
import { slideInAnimation } from './routeanimations';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PlayerService } from './player.service';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    slideInAnimation
    // animation triggers go here
  ]
})
export class AppComponent {
  title = 'Br-ba Irratia';
  start:boolean = false;

  constructor(
    public playerService:PlayerService
  ) {
    playerService.init_app$
    .subscribe(
      (res:boolean) => {
          this.start = res;
      }
    )
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
